export default "__VITE_ASSET__9fc3d5fb__"